import { get } from "./requests";
import { URL_BASE } from "./constants";

export async function getAllCities(state) {
    const response = await get(`${URL_BASE}/cities/?stateCode=${state}`);
    return response.data;
}

export async function getById(id) {
    const response = await get(`${URL_BASE}/cities/${id}`);
    return response.data;
}